import axios from "@/api/axiosInstance";
import { GetLibraryModuleResponse } from "./types";

export const getLibraryModule = async (
  uuid: string,
): Promise<GetLibraryModuleResponse> => {
  const response = await axios.get<GetLibraryModuleResponse>(
    `/api/private/learning-center/module-library/${uuid}`,
  );
  return response.data;
};
